import { generateKeyFromString, getDomainWithoutSubdomain } from "@/utils";
import { getFileHtml } from "@/helpers/UrlToHtml";

export async function getOgImageFromHTML(url) {
  try {
    const urlKey = generateKeyFromString(url);

    const urlFromStorage = window.sessionStorage.getItem(urlKey);

    if (!urlFromStorage) {
      const doc = await getFileHtml(url);

      // Find the og:image meta tag
      const ogImageMetaTag = doc.querySelector('meta[property="og:image"]');
      if (ogImageMetaTag) {
        const ogImage = ogImageMetaTag.getAttribute('content');
        if (ogImage) {
          window.sessionStorage.setItem(urlKey, ogImage);
        }
        return ogImage;
      } else {
        const parsedDomain = getDomainWithoutSubdomain(url);
        return `https://${parsedDomain}/favicon.ico`;
      }
    } else {
      return urlFromStorage;
    }
  } catch (error) {
    console.error('Error fetching or parsing the URL:', error);
    return null;
  }
}
